import { InvoiceReviewStatusSchema, type InvoiceReviewStatus } from '@weft/types';
import { useStateParams } from 'apps/app/src/hooks/use-state-params';
import { serializeStringArrayParam } from 'apps/app/src/utils/params-formatting';
import { DEFAULT_INVOICES_TABLE_SELECTED_WORKFLOW } from '../invoices-page-consts';

export function useSelectedWorkflowsParam() {
  return useStateParams<InvoiceReviewStatus[]>(DEFAULT_INVOICES_TABLE_SELECTED_WORKFLOW, 'workflow', serializeStringArrayParam, deserializeWorkflows);
}

function deserializeWorkflows(WorkflowsArray: string): InvoiceReviewStatus[] | null {
  const workflows = WorkflowsArray.split(',');

  return workflows.map((workflow) => {
    return InvoiceReviewStatusSchema.parse(workflow);
  });
}